<template>
  <v-dialog
    v-model="isShow"
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip
        top
        color="black"
        :activator="$refs.btn"
        :value="tooltip"
      >
        <span>{{ $t('TaskList.Transfer.SystemMessage') }} / {{ $t('TaskList.Rollback.SystemMessage') }}</span>
      </v-tooltip>

      <v-btn
        ref="btn"
        icon
        color="light-blue"
        :class="cssClass"
        :disabled="disabled"
        v-on="on"
        @mouseover="tooltip = true"
        @mouseleave="tooltip = false"
      >
        <v-icon>
          {{ mdiRedo }}
        </v-icon>
        <!-- 轉交 -->
      </v-btn>
    </template>
    <v-card>
      <v-tabs v-model="tabNum">
        <v-tab>{{ $t('TaskList.TransferToOthers') }}</v-tab>
        <v-tab v-if="task.workItemHistoryList && task.workItemHistoryList.length">
          {{ $t('TaskList.Rollback') }}
        </v-tab>
      </v-tabs>
      <br>
      <v-form
        ref="transferForm"
      >
        <v-card-text>
          <v-text-field
            v-if="requireMessage"
            v-model="task.newMessage"
            :append-icon="mdiMessageText"
            :label="$t('TaskList.MsgToNext')"
            :disabled="isApprove(task.status)"
          />
          <!-- 轉交專用 -->
          <s-search-staff
            v-if="tabNum === 0"
            show-support-staff
            show-group
            :select.sync="reassignedToEuid"
            :staff.sync="reassignedToStaffObj"
            :label="$t('TaskList.TransferToOthers')"
          />
          <!-- 退回專用 -->
          <v-select
            v-if="tabNum === 1"
            v-model="reassignedToHistoryItem"
            :items="workItemHistoryList"
            :item-value="item => item"
            :item-text="item => staffOrGroupName(item)"
            hide-details
            :rules="rules.requiredField"
            :label="$t('PublicServant.Staff')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="isShow = false"
          >
            {{ $t('PublicServant.Action.Close') }}
          </v-btn>
          <v-btn
            :loading="loading"
            text
            color="primary"
            @click="confirm"
          >
            {{ $t('ConfirmModal.OK') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
  <!-- </div> -->
</template>

<script>
import { mdiRedo, mdiMessageText } from '@mdi/js'
import { mapState } from 'vuex'
import VuetifyJetValidator from 'vuetify-jet-validator'

import SSearchStaff from '@/components/SSearchStaff'
import { staffModule } from '@/store/moduleName'
import { taskMethod } from '@/mixins/taskMethod'
import { SEARCH_STAFF_RECORD_TYPE } from '@/constant/constant'
import _ from 'lodash'

const validator = new VuetifyJetValidator()

export default {
  components: {
    SSearchStaff
  },
  mixins: [taskMethod],
  props: {
    requireMessage: {
      type: Boolean,
      default: true
    },
    task: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cssClass: {
      type: String,
      default: null
    },
    currGroupId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      mdiRedo: mdiRedo,
      mdiMessageText: mdiMessageText,
      reassignedToEuid: '',
      reassignedToStaffObj: null,
      reassignedToHistoryItem: null,
      tabNum: this.task.workItemHistoryList ? 0 : 1,
      isShow: false,
      tooltip: false,
      loading: false,
      rules: {
        requiredField: [
          validator.rules.required(this.$t('TrainingClient.RequiredField'))
        ]
      }
    }
  },
  computed: {
    ...mapState(staffModule, {
      // staffPhoto: state => state.photoInBase64,
      staff: state => state.info
    }),
    workItemHistoryList: function () {
      if (!this.task.workItemHistoryList) return
      let flags = {} // use to mark which data already exist
      return this.task.workItemHistoryList.filter((workItemHistory) => {
        if (workItemHistory.messageFromGroupId) {
          if (workItemHistory.messageFromGroupId === this.currGroupId) { // don't return to the current group
            return false
          } else if (flags[workItemHistory.messageFromGroupId]) {
            return false
          } else {
            flags[workItemHistory.messageFromGroupId] = true
            return true
          }
        } else {
          if (workItemHistory.euid === this.staff.euid && !this.currGroupId) { // don't add himself to the list
            return false
          } else if (flags[workItemHistory.euid]) {
            return false
          } else {
            flags[workItemHistory.euid] = true
            return true
          }
        }
      })
    }
  },
  watch: {
    tabNum: {
      handler: function (val) {
        this.reassignedToEuid = null
        this.reassignedToStaffObj = null
        this.reassignedToHistoryItem = null

        if (val === 1) { // 退回上一位
          if (this.workItemHistoryList && this.workItemHistoryList.length) {
            this.reassignedToHistoryItem = this.workItemHistoryList[0]
          }
        }
      },
      immediate: true
    }
  },
  created () {
    this.confirm = _.debounce(this.debounceConfirm, 1000, { leading: true, trailing: false })
  },
  methods: {
    staffOrGroupName (item) {
      if (this.$chPtObjData('messageFromGroupChinName', item)) {
        return this.$chPtObjData('messageFromGroupChinName', item)
      } else {
        return this.$chPtObjData('chinStaffName', item)
      }
    },
    debounceConfirm: function () {
      this.loading = true
      if (!this.$refs.transferForm.validate()) {
        this.loading = false
        return false
      }

      let isRollback = false
      if (this.reassignedToHistoryItem) {
        isRollback = true
        if (this.reassignedToHistoryItem.messageFromGroupId) {
          this.reassignedToEuid = this.reassignedToHistoryItem.messageFromGroupId + ''
          this.reassignedToStaffObj = {
            recordType: SEARCH_STAFF_RECORD_TYPE.GROUP
          }
        } else {
          this.reassignedToEuid = this.reassignedToHistoryItem.euid
        }
      }

      if (this.reassignedToEuid === null) {
        return false
      }

      this.$emit('transfer-task', { defaultNextEuid: this.reassignedToEuid, nextStaffObj: this.reassignedToStaffObj, isRollback: isRollback })
    }
  }
}
</script>
